module.exports = __webpack_public_path__ + "img/layer_4.673f1a1b.png";